import { Popover, Button } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import "./index.less";
import selected from "./img/selected.png";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";

function FontContent({
  onclick,
  isSelectedColor,
  setSelectColor
}: {
  onclick: any;
  isSelectedColor: string;
  setSelectColor: any;
}) {
  const fontSize = ["常规", "中号", "大号"];
  const ctsTags = ["Normal", "Medium", "Large"];
  const fontColor = ["#232930", "#F3210E", "#FF7800", "#63BD08", "#20C9D8", "#3641FF", "#E73495"];
  let quill = document.querySelector(".ql-editor") as HTMLElement;
  const [isNormalSize, setNormalSize] = useState(true);
  const [isMidSize, setMidSize] = useState(false);
  const [isBigSize, setBigSize] = useState(false);
  const sizeState = [isNormalSize, isMidSize, isBigSize];
  const getClass = useCallback(
    (index) => {
      return classNames({
        sizeBtn: true,
        "size-selected": sizeState[index]
      });
    },
    [sizeState]
  );
  return (
    <div className="font-container">
      <div className="font-size">
        <div className="font-title">字号</div>
        <div>
          {fontSize.map((size, index) => {
            return (
              <Button
                className={getClass(index)}
                clstag={`pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_${ctsTags[index]}`}
                key={index}
                onClick={() => {
                  onclick();
                  switch (size) {
                    case "常规":
                      quill.style.fontSize = "12px";
                      setNormalSize(true);
                      setMidSize(false);
                      setBigSize(false);
                      break;
                    case "中号":
                      quill.style.fontSize = "15px";
                      setNormalSize(false);
                      setMidSize(true);
                      setBigSize(false);
                      break;
                    case "大号":
                      quill.style.fontSize = "18px";
                      setNormalSize(false);
                      setMidSize(false);
                      setBigSize(true);
                      break;
                  }
                }}
              >
                {size}
              </Button>
            );
          })}
        </div>
      </div>
      <div className="font-color">
        <div className="font-title">文本颜色</div>
        <div className="color-container">
          {fontColor.map((colors, index) => {
            const colorSelect = {
              backgroundColor: colors,
              width: 22,
              height: 22,
              marginRight: "5px",
              borderRadius: "2px",
              cursor: "pointer",
              display: "flex"
            };
            return (
              <span
                style={colorSelect}
                className="colorSelect"
                key={index}
                onClick={() => {
                  onclick();
                  quill.style.color = colors;
                  setSelectColor(colors);
                }}
              >
                {isSelectedColor === colors && <img src={selected} />}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}
function FontPopover({
  children,
  visible,
  onVisibleChange,
  placement,
  isSelectedColor,
  setSelectColor
}: {
  children: any;
  visible: boolean;
  onVisibleChange: (visible: boolean) => void;
  placement?: any;
  isSelectedColor: string;
  setSelectColor: any;
}) {
  function handleClick() {
    onVisibleChange(false);
  }
  const classes = useMemo(() => {
    return classNames({
      "font-popover": true
    });
  }, []);
  return (
    <Popover
      trigger="click"
      overlayClassName={classes}
      placement={placement || "top"}
      visible={visible}
      onVisibleChange={(visible) => {
        onVisibleChange(visible);
      }}
      content={
        <FontContent
          onclick={handleClick}
          isSelectedColor={isSelectedColor}
          setSelectColor={setSelectColor}
        />
      }
    >
      {children}
    </Popover>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  return {
    isSelectedColor: chat.isSelectedColor
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    setSelectColor(data: any) {
      dispatch({ type: "chat/setSelectColor", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(FontPopover);
